import { ApolloClient } from 'apollo-client';
import { from } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

import { cfetch } from '@confluence/network';

// @ts-ignore
import fragmentMatcherAGGTypes from './types/fragmentMatcherAGGTypes';
import { createOnErrorLink } from './links/OnErrorLink';

let apolloClient: ApolloClient<Object>;

const fragmentMatcher = new IntrospectionFragmentMatcher({
	introspectionQueryResultData: {
		__schema: {
			types: fragmentMatcherAGGTypes,
		},
	},
});

export const getAGGClient = (): ApolloClient<object> => {
	// Use mock gateway Apollo client in tests
	if ((window as any).MOCK_GATEWAY_APOLLO_CLIENT) {
		return (window as any).MOCK_GATEWAY_APOLLO_CLIENT;
	}

	if (!apolloClient) {
		apolloClient = createApolloClient();
	}
	return apolloClient;
};

const createApolloClient = (): ApolloClient<object> => {
	return new ApolloClient({
		connectToDevTools: process.env.NODE_ENV !== 'production',
		link: from([
			createOnErrorLink(),
			new HttpLink({
				credentials: 'include',
				uri: '/gateway/api/graphql',
				fetch: cfetch,
			}),
		]),
		cache: new InMemoryCache({
			fragmentMatcher,
		}),
	});
};
